// extracted by mini-css-extract-plugin
export default {"titleUp":"PjWH9DtI","valueTitle":"D_o_gpfM","sliderWrapper":"jLlTqtQY"};